import React, { useEffect, useState, useContext } from 'react'
import Paper from '@mui/material/Paper';
import { Divider } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Link } from 'react-router-dom';
import api from '../../API/api';
import { SchoolContex } from '../../Helper/Contex';
import EventIcon from '@mui/icons-material/Event';
import Loader from '../../AdminPages/panel/loader';

const Notice = () => {

    const htmlToFormattedText = require("html-to-formatted-text");

    const [notice, setNotice] = useState();
    const [events, setEvents] = useState();
    const [color, setColor] = useState(1);
    const [load, setLoad] = useState(false);

    const schoolData = useContext(SchoolContex);
    // console.log(schoolData, 'schoolData');
    useEffect(() => {
        getEventAndNotice();
    }, []);

    const getEventAndNotice = () => {
        api.getEventAndNotice().then((res) => {
            // console.log(res, 'sda');
            setEvents(res.data.events)
            setNotice(res.data.notice)
        })
    }

    function handleNoticeUpdate(e) {
        // console.log(e.target.value, 'scolld id');
        if (e.target.value == 1) {
            api.getEventAndNotice().then(res => {
                setNotice(res.data.notice)
            })
        } else {
            api.getEventAndNotice().then((res) => {
                let newNotice = res.data.notice?.filter(obj => e.target.value.includes(obj.school))
                setNotice(newNotice)
            })
        }

        // console.log(newNotice ,'newNotice');
    }
    // pending select box 

    function handlePastEvent(data) {
        setLoad(true);
        let current = new Date();
        api.getEventAndNotice().then((res) => {
            let newNotice = res.data.events.filter(obj => {
                let evntDate = new Date(obj.date)
                if (data == 1) {
                    setColor(2)
                    if (evntDate < current.getTime()) {
                        setLoad(false);
                        return obj;
                    }
                } else if (data == 2) {
                    setColor(3)
                    if (evntDate > current.getTime()) {
                        setLoad(false);
                        return obj;
                    }
                } else {
                    setColor(1)
                    setLoad(false);
                    return obj;
                }
                return;
            })
            setEvents(newNotice);
            setLoad(false);
        })
        // setLoad(false);
    }



    return (
        <>
            <div className='my-2'>
                <Paper elevation={3}>
                    <div className='noticeEvents py-5 px-2'>
                        <div className="text-center pb-4">
                            <h2> NOTICE & EVENTS </h2>
                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <Paper elevation={3} style={{ height: '100%' }}>
                                    <div className='notice h-100 p-3'>
                                        <h2> Notice Board </h2>
                                        <div className='categories'>
                                            <div className='form-group d-flex align-items-center'>
                                                <div className='col-4 col-md-3'>
                                                    <small style={{ whiteSpace: 'nowrap' }}>CATEGORIES :</small>
                                                </div>
                                                <div className='col-8 col-md-8'>
                                                    <select name='select' className='form-select' onChange={handleNoticeUpdate}>
                                                        <option value={'1'}>All</option>
                                                        {schoolData.schools?.map(obj => (
                                                            <option value={obj.schoolName}>{obj.schoolName}</option>
                                                        )
                                                        )}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='notice-box'>
                                            {notice?.length > 0 ?
                                                notice.map((n) =>
                                                (
                                                    <>
                                                        <div className='m-2'>
                                                            <Paper elevation={3} className='p-3'>

                                                                {/* <a href={`${process.env.REACT_APP_BACKEND}assets/notice/${n.file}`} target='_blank' className='text-dec-none'> */}
                                                                <a href={n.file ? `${process.env.REACT_APP_BACKEND}assets/notice/${n.file}` : `${n.link}`} target='_blank' className='text-dec-none'>
                                                                    {n.notice}

                                                                   { new Date(n.created_at) > new Date() && <img src={require('../../new.gif')} height="12px" /> }
                                                                    
                                                                    {
                                                                        n.school === 'All' ?
                                                                            '' :
                                                                            <div className='locationNotice'>
                                                                                <div>
                                                                                    <LocationOnIcon style={{ fontSize: 16 }} />
                                                                                </div>
                                                                                <p>{n.school}</p>
                                                                            </div>
                                                                    }
                                                                </a>
                                                            </Paper>
                                                        </div>
                                                    </>
                                                )) :
                                                <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <p>No New Notice</p>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {/* {list} */}
                                </Paper>
                            </div>
                            <div className="col-md-8">
                                <Paper elevation={3} className='h-100'>
                                    <div className='events p-3'>
                                        <div className='top p-md-3 p-2'>
                                            <div>
                                                <h4> Events </h4>
                                            </div>
                                            <div>
                                                <button className={`btn action ${color == 1 ? 'activebtn' : ''}`} onClick={() => handlePastEvent()}>All</button>
                                                <button className={`btn action ${color == 2 ? 'activebtn' : ''}`} onClick={() => handlePastEvent(1)}>PAST</button>
                                                <button className={`btn action ${color == 3 ? 'activebtn' : ''}`} onClick={() => handlePastEvent(2)} >UPCOMING</button>
                                            </div>
                                        </div>
                                        <Divider variant="middle" sx={{ borderBottomWidth: 2, borderColor: 'black' }} />

                                        <div className="row">
                                            {load ? <Loader /> :
                                                <>
                                                    {events && events.slice(0, 4).map((ev) =>
                                                    (
                                                        <div className="col-md-6 p-3">
                                                            <Paper elevation={1} sx={{
                                                                ':hover': {
                                                                    boxShadow: 10,
                                                                },
                                                            }} className='event-box position-relative'>
                                                                <div className='row'>
                                                                    <div className='col-5 border text-center'>
                                                                        <img src={`${process.env.REACT_APP_BACKEND}assets/events/img/${ev.image}`} className=' col-12' alt={ev.event} />

                                                                        <div className='text-center p-2'>
                                                                            <div className='locationDate px-3'>
                                                                                <EventIcon style={{ fontSize: 18 }} /> 
                                                                                {new Date(ev.date).toDateString().slice(4, 20)}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-7'>
                                                                        <Link to="singleEvent" state={ev}>
                                                                            <div className='p-2'>
                                                                                <div>
                                                                                    <h6 style={{ height: 40, overflow: 'hidden' }}>
                                                                                        <strong> {ev.event}</strong>
                                                                                    </h6>
                                                                                </div>
                                                                                <div className='row align-item-center '>
                                                                                    <div className='col-md-12 col-12 p-0'>
                                                                                        {ev.school &&
                                                                                            <div className='locationNotice py-1'>
                                                                                                <LocationOnIcon style={{ fontSize: 18 }} />
                                                                                                <small className=''> {ev.location ? ev.location: ev.school}</small>
                                                                                            </div>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                <div className='pt-2' style={{ height: 125, display: 'flex', overflow: 'hidden', }}>
                                                                                    <span className='align-bottom'>
                                                                                        <div dangerouslySetInnerHTML={{ __html: ev.details }} />
                                                                                    </span>
                                                                                </div>
                                                                                <div className='text-end'>
                                                                                    <small>
                                                                                        <Link to='singleEvent' state={ev}>Read more...</Link>
                                                                                    </small>
                                                                                </div>
                                                                            </div>
                                                                        </Link>
                                                                        {/* </a> */}
                                                                    </div>
                                                                    {/* <div className=''>
                                                                        {
                                                                            ev.date &&
                                                                            <div className='locationNotice date'>
                                                                                <EventIcon style={{ fontSize: 18 }} />
                                                                                {new Date(ev.date).toDateString().slice(4, 20)}
                                                                            </div>
                                                                        }
                                                                    </div> */}
                                                                </div>
                                                            </Paper>
                                                        </div>
                                                    ))}
                                                </>
                                            }

                                            <div className="text-end">
                                                <Link to="allEvents" className='allEventsbtn'>More Events</Link>
                                            </div>
                                        </div>

                                    </div>

                                </Paper>
                            </div>
                        </div>
                    </div>
                </Paper>
            </div>
        </>
    )
}

export default Notice;